<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                v-model="queryParams.productCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm5 v-if="user.roleName == 'ADMIN' || user.roleName == 'BRANCH_ADMIN'">
              <v-select
                :items="warehouseList"
                label="Warehouse"
                v-model="queryParams.warehouseId"
                item-text="name"
                item-value="id"
                menu-props="auto"
                autocomplete
                multiple
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="categoryList"
                label="Cateogry"
                v-model="queryParams.categoryId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="brandList"
                label="Brand"
                v-model="queryParams.brandId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="productGroupList"
                label="ProductGroup"
                v-model="queryParams.productGroupId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="balanceList"
                label="Balance"
                v-model="queryParams.balanceFlag"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex d-flex xs12>
              <v-card>
                <v-card-text class="font-weight-bold">
                  <div>
                    <v-btn
                      :loading="printAllButtonLoading"
                      color="primary"
                      @click="printAllStockBalance('printStockBalance')"
                    >PRINT ALL</v-btn>
                    <v-btn
                      :loading="printAllButtonLoading"
                      color="success"
                      @click="exportAllStockBalance()"
                    >EXPORT ALL</v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :must-sort="true"
                  :headers="headers"
                  :items="stockList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                >
                  <template slot="items" slot-scope="props">
                    <tr :style="(props.item.reorderQty > 0 && props.item.qty <= props.item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">
                      <td>{{ props.item.warehouse.name }}</td>
                      <td>{{ props.item.product.name }}</td>
                      <td>{{ props.item.product.code }}</td>
                      <td>{{ props.item.product.color }}</td>
                      <td>{{ props.item.category.name }}</td>
                      <td>{{ props.item.product.productGroupName }}</td>
                      <td>{{ props.item.brand.name }}</td>
                      <td>{{ props.item.productUnit.factor+"/"+props.item.productUnit.unitName}}</td>
                      <td>{{ props.item.reorderQty }}</td>
                      <td>{{ props.item.qty }}</td>
                      <td>
                        <v-btn color="primary" @click="showDetail(props.item)">Detail</v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showDetailDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="detailqueryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="detailqueryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="detailqueryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="detailqueryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm1></v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="detailqueryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="transactionstatusList"
                label="Transaction Type"
                v-model="detailqueryParams.type"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchDetail">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-card>
            <v-card-text class="font-weight-bold">
              <div>
                <span>Product Code :</span>
                <v-chip>
                  <span>{{ productCode}}</span>
                </v-chip>

                <span>Product Name :</span>
                <v-chip>
                  <span>{{ productName}}</span>
                </v-chip>
              </div>
              <div>
                <span>Warehouse Name :</span>
                <v-chip>
                  <span>{{ warehouseName}}</span>
                </v-chip>

                <span>In / Out /Total :</span>
                <v-chip>
                  <span>{{ inQty | numFormat}} / {{outQty | numFormat}} / {{ totalQty | numFormat }}</span>
                </v-chip>
                <v-btn
                  :loading="printAllButtonLoading"
                  color="primary"
                  @click="printStockBalanceDetail('printStockBalanceDetail')"
                >PRINT ALL</v-btn>
              </div>
            </v-card-text>
          </v-card>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="detailheaders"
                :items="detailList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRowsDetail"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="detailpagination"
                :must-sort="false"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.stockBalanceDetail.issueDateInMilliSeconds | format-ms-date-time }}</td>
                  <td>{{ props.item.stockBalanceDetail.issueNo }}</td>
                  <td>{{ props.item.stockBalanceDetail.transactionType }}</td>
                  <td>{{ props.item.stockBalanceDetail.qty }}</td>
                  <td>{{ props.item.stockBalanceDetail.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <summary report> -->
    <div id="printStockBalance" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Stock Balance Report</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;
          width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Warehouse Name</th>
              <th style="text-align:left">Product Name</th>
              <th style="text-align:left">Product Code</th>
              <th style="text-align:left">Product Color</th>
              <th style="text-align:left">Category Nmae</th>
              <th style="text-align:left">Product Group</th>
              <th style="text-align:left">Brand</th>
              <th style="text-align:left">Factor/Unit</th>
              <th style="text-align:left">Reorder Level</th>
              <th style="text-align:left">Qty</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allStockList" :key="index">
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.warehouse.name}}</td>
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.product.name}}</td>
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.product.code}}</td>
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.product.color}}</td>
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.category.name}}</td>
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.product.productGroupName}}</td>
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.brand.name}}</td>
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.productUnit.factorUnitName}}</td>
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.productUnit.reorderQty}}</td>
              <td style="text-align:left" :style="(item.reorderQty > 0 && item.qty <= item.reorderQty) ? {backgroundColor: '#FA8072'} : {backgroundColor: '#FFFFFF'}">{{item.qty}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <summary report> -->
    <div id="printStockBalanceDetail" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Stock Balance Detail Report</p>
      </div>
      <br />
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Product Code: {{ productCode}}</p>
      </div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Product Name : {{ productName}}</p>
      </div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Warehouse Name : {{ warehouseName}}</p>
      </div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Total Qty : {{ totalQty}}</p>
      </div>
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;
          width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Date</th>
              <th style="text-align:left">Issue No</th>
              <th style="text-align:left">Transaction Type</th>
              <th style="text-align:left">Qty</th>
              <th style="text-align:left">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allDetailList" :key="index">
              <td
                style="text-align:left"
              >{{ item.stockBalanceDetail.issueDateInMilliSeconds | format-ms-date-time }}</td>
              <td style="text-align:left">{{ item.stockBalanceDetail.issueNo }}</td>
              <td style="text-align:left">{{ item.stockBalanceDetail.transactionType }}</td>
              <td style="text-align:left">{{ item.stockBalanceDetail.qty }}</td>
              <td style="text-align:left">{{ item.stockBalanceDetail.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { stockService } from "../../services/stock-service";
import { categoryService } from "../../services/category-service";
import { brandService } from "../../services/brand-service";
import { warehouseService } from "../../services/warehouse-service";
import { productGroupService } from "../../services/product-group-service";
import { commonService } from "../../services/common-service";

export default {
  name: "StockList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Product Mangement",
        disabled: true
      },
      {
        text: "Stock Balance",
        disabled: true
      }
    ],
    headers: [
      { text: "Warehouse", align: "left", value: "warehouseName" },
      { text: "Product Name", value: "productName" },
      { text: "Product Code", value: "productCode" },
      { text: "Product Color", value: "productColor" },
      { text: "Category", value: "product.category.name" },
      { text: "Product Group", value: "product.productGroup.name" },
      { text: "Brand", value: "product.brand.name" },
      { text: "Factor/Unit", value: "productUnit.unitName" },
      { text: "Reorder Level", value: "product.reorderQty" },
      { text: "Qty", value: "qty" },
      { text: "Detail", value: "Detail" }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "warehouseName",
      totalItems: 0
    },
    detailpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "warehouseName",
      totalItems: 0
    },
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    balanceList: [
      { label: "----All----", value: "" },
      { label: "With Balance", value: "TRUE" },
      { label: "Without Balance", value: "FALSE" }
    ],
    productCode: "",
    productName: "",
    warehouseName: "",
    totalQty: "",
    inQty: "",
    outQty: "",
    showDetailDialog: false,
    detailqueryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      type: "",
      productId: "",
      warehouseId: ""
    },
    detailList: [],
    allDetailList: [],
    totalRowsDetail: 0,
    detailheaders: [
      { text: "Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Transaction Type", value: "transactionType" },
      { text: "Qty", value: "qty" },
      { text: "Description", value: "description" }
    ],
    transactionstatusList: [
      { label: "----All----", value: "" },
      { label: "STOCK IN", value: "STOCK IN" },
      { label: "STOCK TRANSFER IN", value: "STOCK TRANSFER IN" },
      { label: "STOCK TRANSFER OUT", value: "STOCK TRANSFER OUT" },
      { label: "STOCK ADJUSTMENT IN", value: "STOCK ADJUSTMENT IN" },
      { label: "STOCK ADJUSTMENT OUT", value: "STOCK ADJUSTMENT OUT" },
      { label: "WHOLE SALE", value: "WHOLE SALE" },
      { label: "WHOLE SALE FOC", value: "WHOLE SALE FOC" },
      { label: "WHOLE SALE RETURN", value: "WHOLE SALE RETURN" },
      { label: "RETAIL SALE", value: "RETAIL SALE" },
      { label: "RETAIL SALE FOC", value: "RETAIL SALE FOC" },
      { label: "RETAIL SALE RETRUN", value: "RETAIL SALE RETURN" }
    ],
    buttonLoading: false,
    printAllButtonLoading: false,
    stockList: [],
    allStockList: [],
    categoryList: [],
    brandList: [],
    warehouseList: [],
    productGroupList: [],
    totalRows: 0,
    clonequeryParams: new Object(),
    queryParams: {
      productCode: "",
      categoryId: "",
      brandId: "",
      warehouseId: [],
      productGroupId: "",
      status: "",
      balanceFlag: "",
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockList();
      },
      deep: true
    },
    detailpagination: {
      handler() {
        this.onSearchDetail();
      },
      deep: true
    }
  },
  created() {
    this.queryParams.status = "ACTIVE";
    //for deep linking
    if (this.$route.query.productCode) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.user.roleName == "ADMIN" ||this.user.roleName == "BRANCH_ADMIN") {
      this.getWarehouseList();
    }
    this.getCategoryList();
    this.getBrandList();
    this.getWarehouseList();
    this.getProductGroupList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "stock-balances", query: this.queryParams });
      this.getStockList();
    },
    getWarehouseList() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCategoryList() {
      categoryService
        .getAllCategory()
        .then(res => {
          this.categoryList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.categoryList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getBrandList() {
      brandService
        .getAllBrand()
        .then(res => {
          this.brandList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.brandList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProductGroupList() {
      productGroupService
        .getAllProductGroup()
        .then(res => {
          this.productGroupList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.productGroupList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch(err => {
          console.log(err);
        });
    },
    getStockList() {
      this.showListLoading = true;
      this.buttonLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockService
        .getStockList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.stockList = res.data.stockList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
          this.buttonLoading = false;
        });
    },
    printAllStockBalance(divName) {
      this.printAllButtonLoading = true;
      stockService
        .getAllStockList(this.queryParams)
        .then(res => {
          if (res.data) {
            this.allStockList = res.data.stockList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    printStockBalanceDetail(divName) {
      this.showListLoading = true;
      this.buttonLoading = true;
      this.allDetailList = [];
      stockService
        .getAllDetailList(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.allDetailList = res.data.stockList;
            this.totalRowsDetail = res.data.totalElements;
            this.totalQty = res.data.totalQty;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
          this.buttonLoading = false;
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
        });
    },
    showDetail(stockbalance) {
      this.productCode = stockbalance.product.code;
      this.productName = stockbalance.product.name;
      this.warehouseName = stockbalance.warehouse.name;
      this.detailqueryParams.type = "";
      this.detailqueryParams.productId = stockbalance.product.id;
      this.detailqueryParams.warehouseId = stockbalance.warehouse.id;
      this.detailqueryParams.issueNo = "";
      this.detailqueryParams.fromDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.detailqueryParams.toDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.showDetailDialog = !this.showDetailDialog;
      this.onSearchDetail();
    },
    onSearchDetail() {
      this.showListLoading = true;
      this.buttonLoading = true;
      this.$router.replace({
        name: "stock-balances",
        query: this.detailqueryParams
      });
      this.getDetailList();
      this.clonequeryParams = Object.assign({}, this.detailqueryParams);
    },
    getDetailList() {
      //let order = this.pagination.descending ? "desc" : "asc";
      this.detailList = [];
      this.totalQty = 0;
      stockService
        .getDetailList(
          this.detailqueryParams,
          this.detailpagination.page,
          this.detailpagination.rowsPerPage
          // this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.detailList = res.data.stockList;
            this.totalRowsDetail = res.data.totalElements;
            this.totalQty = res.data.totalQty;
            this.inQty = res.data.inQty;
            this.outQty = res.data.outQty;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
          this.buttonLoading = false;
        });
    },
    exportAllStockBalance() {
      this.printAllButtonLoading = true;
      stockService
        .exportStockBalanceExcel(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    }
  }
};
</script>
